import { Outlet } from "react-router-dom";
import Drawer from "../../commons/drawer/drawer";
import Header from "../../commons/header/header";
import { StyledAuthRoutes } from "../../styled/layout";
// Layout with header and drawer
const MainLayout = ({ mobileOpen, handleDrawerToggle }) => (
  <StyledAuthRoutes.Root>
    <Header handleDrawerToggle={handleDrawerToggle} open={mobileOpen} />
    <Drawer open={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
    <StyledAuthRoutes.Content open={mobileOpen}>
      <Outlet />
    </StyledAuthRoutes.Content>
  </StyledAuthRoutes.Root>
);

export default MainLayout;  
